import classNames from 'classnames';
import styles from './input.module.scss';

export enum RsInputSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export const sizeMap = {
  [RsInputSize.LARGE]: classNames(styles.size, styles.large),
  [RsInputSize.MEDIUM]: classNames(styles.size, styles.medium),
  [RsInputSize.SMALL]: classNames(styles.size, styles.small),
};
